// extracted by mini-css-extract-plugin
export var menu = "header-module--menu--30509";
export var menuOpened = "header-module--menuOpened--6609b";
export var nav = "header-module--nav--a626b";
export var scrolled = "header-module--scrolled--3c726";